export const RAMBLA_URL = 'https://rambla.io/'
export const IOS_APP_URL = 'https://hausmart.is/rambla-ios'
export const ANDROID_APP_URL = 'https://hausmart.is/ramblas-android'
export const SHOPIFY_APP_STORE_URL = 'https://apps.shopify.com/rambla'

export const HAUSMART_GET_STARTED_URL = 'https://apps.apple.com/us/app/hausmart-start-selling/id1363222610'

export const HAUSMART_IOS_APP_URL = 'http://bit.ly/HausMartiOS'
export const HAUSMART_ANDROID_APP_URL = 'http://bit.ly/HausMartAndroid'
export const ZEROTOUCH_IOS_APP_URL = 'https://bit.ly/ZeroTouchiOS'
export const ZEROTOUCH_ANDROID_APP_URL = 'https://bit.ly/ZeroTouchAndroid'

export const HAUSMART_SOCIAL = {
  facebook: 'https://www.facebook.com/hausmartapp/',
  instagram: 'https://www.instagram.com/hausmartapp/',
  linkedin: 'https://www.linkedin.com/company/hausmartapp'
}
